var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialByDirectoryActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Dial_by_Directory_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dial_by_Directory_Active",
    "data-name": "Dial by Directory_Active",
    clipPath: "url(#clip-Dial_by_Directory_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contacts",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_71",
    "data-name": "Subtraction 71",
    d: "M23.4,28.507H.98a.981.981,0,0,1-.98-.98V.98A.981.981,0,0,1,.98,0H23.4a.981.981,0,0,1,.98.98V27.527A.981.981,0,0,1,23.4,28.507ZM8.1,8.512a1.121,1.121,0,0,0-.74.278,7.956,7.956,0,0,0-1.777,1.858,3.215,3.215,0,0,0,.257,2.622A14.886,14.886,0,0,0,14.2,20.35a3.236,3.236,0,0,0,.426.076l.027,0,.112.017a1.855,1.855,0,0,1,.234.043,2.2,2.2,0,0,0,.346.04,2.473,2.473,0,0,0,1.7-.815,4.994,4.994,0,0,0,.59-.7L17.641,19l.563-.8a1.172,1.172,0,0,0-.266-1.6l-2.191-1.579a1.136,1.136,0,0,0-1.609.278,2.132,2.132,0,0,1-.868.844A11.3,11.3,0,0,1,11.7,14.948a13.638,13.638,0,0,1-1.6-1.609,4.571,4.571,0,0,1,.711-.894,1.172,1.172,0,0,0,0-1.619L8.916,8.88A1.165,1.165,0,0,0,8.1,8.532Zm7.244,11.2a.6.6,0,0,1-.187-.02c-.141-.029-.277-.049-.408-.067s-.257-.036-.362-.062a14.171,14.171,0,0,1-7.816-6.624c-.145-.338-.586-1.368-.286-1.917A9.121,9.121,0,0,1,7.871,9.406.347.347,0,0,1,8.1,9.317v-.01a.377.377,0,0,1,.257.109l1.9,1.947a.351.351,0,0,1,0,.5c-.315.325-1.039,1.126-.967,1.559s1.551,1.8,1.914,2.116a13.028,13.028,0,0,0,1.717,1.291.793.793,0,0,0,.356.089c.653,0,1.287-.833,1.53-1.192a.345.345,0,0,1,.286-.148.327.327,0,0,1,.207.069l2.191,1.58a.352.352,0,0,1,.078.5l-.572.815C16.982,18.545,16.2,19.715,15.341,19.715Z",
    transform: "translate(2.702 0.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4637",
    "data-name": "Path 4637",
    d: "M31.8,37.24H11.949a3.012,3.012,0,0,1-3-3.015V10.255a3.012,3.012,0,0,1,3-3.015H31.8a3.012,3.012,0,0,1,3,3.015v8.567a.682.682,0,1,1-1.363,0V10.255A1.623,1.623,0,0,0,31.82,8.628H11.966a1.637,1.637,0,0,0-1.636,1.628V34.225a1.626,1.626,0,0,0,1.636,1.628H31.82a1.623,1.623,0,0,0,1.619-1.628V24.082a.682.682,0,1,1,1.363,0V34.225A3.012,3.012,0,0,1,31.8,37.24Z",
    transform: "translate(-6.978 -7.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2108",
    "data-name": "Group 2108",
    transform: "translate(0 3.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4642",
    "data-name": "Path 4642",
    d: "M12.377,11.415H8.617a.737.737,0,1,1,0-1.475h3.76a.737.737,0,1,1,0,1.475Z",
    transform: "translate(-7.88 -9.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4643",
    "data-name": "Path 4643",
    d: "M12.377,15.185H8.617a.737.737,0,1,1,0-1.475h3.76a.737.737,0,0,1,0,1.475Z",
    transform: "translate(-7.88 -6.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4644",
    "data-name": "Path 4644",
    d: "M12.377,18.965H8.617a.737.737,0,0,1,0-1.475h3.76a.737.737,0,0,1,0,1.475Z",
    transform: "translate(-7.88 -3.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4645",
    "data-name": "Path 4645",
    d: "M12.377,22.745H8.617a.737.737,0,1,1,0-1.475h3.76a.737.737,0,1,1,0,1.475Z",
    transform: "translate(-7.88 -0.387)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4646",
    "data-name": "Path 4646",
    d: "M24.047,16.872a.739.739,0,0,1-.737-.737v-.387a.737.737,0,1,1,1.475,0v.387A.739.739,0,0,1,24.047,16.872Z",
    transform: "translate(3.021 -1.759)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialByDirectoryActive);
export default __webpack_public_path__ + "static/media/Dial_by_Directory_Active.28b232ae0377004ab1bcbc12f13fd154.svg";
export { ForwardRef as ReactComponent };